<template>
  <div>
    <main-header></main-header>
    <div
      class="row no-gutters"
      :style="`padding-top: ${
        $store.state.user.userId == '' ? '60px' : '0px'
      };`"
    >
      <div class="col-3 bd-r bg-white">
        <div
          class="
            bd-b
            ht-40
            d-flex
            pd-10
            justify-content-between
            text-uppercase
            tx-bolder tx-primary tx-13
          "
        >
          Хайх
          <!-- <div class="mg-l-auto text-muted tx-thin">{{pager.filtered}}/{{pager.rows}}</div> -->
          <div class="mg-l-auto text-muted tx-thin">
            {{ list.length }}/{{ pager.rows }}
          </div>
        </div>
        <div class="pd-10" style="height: calc(100vh - 155px); overflow: auto">
          <div class="mg-b-10">
            <div class="tx-12 text-muted">Нэр</div>
            <input
              v-model="filter.task"
              type="text"
              class="form-control"
              placeholder="Хайх утгаа оруулна уу"
            />
          </div>
          <div class="mg-b-10">
            <div class="tx-12 text-muted">
              {{
                $route.params.lid == 95327 || $route.params.lid == 95326
                  ? "Улсын бүртгэлийн дугаар"
                  : "Улсын бүртгэлийн дугаар"
              }}
            </div>
            <input
              v-model="filter.st1"
              type="text"
              class="form-control"
              placeholder="Хайх утгаа оруулна уу"
            />
          </div>
          <div
            v-for="(s, i) in searches.filter(
              (f) => f.property.filter && f.property.showClient
            )"
            :key="i"
            class="mg-b-10"
          >
            <div class="tx-12 text-muted">{{ s.property.title }}</div>
            <DatePicker
              v-if="s.property.struct == 'date'"
              style="width: 100%"
              v-model="s.property.selectedValues"
              placeholder="Огноо сонгоно уу"
              type="daterange"
              range-separator="-"
              start-placeholder="-c"
              end-placeholder="-н"
            ></DatePicker>
            <template v-else-if="s.property.type == 1 || s.property.type == 2">
              <!-- {{selectedValues}} {{:multiple="s.property.type==2"}} -->
              <Select
                v-if="s.property.type == 1"
                v-model="s.property.textValue"
                clearable
                class="wd-100p"
              >
                <Option
                  :key="`${i}_${vi}`"
                  v-for="(v, vi) in s.property.values"
                  :value="v.id"
                  :label="v.value"
                ></Option>
              </Select>
              <Select
                v-else-if="s.property.type == 2"
                v-model="s.property.selectedValues"
                multiple
                clearable
                class="wd-100p"
              >
                <Option
                  :key="`${i}_${vi}`"
                  v-for="(v, vi) in s.property.values"
                  :value="v.id"
                  :label="v.value"
                ></Option>
              </Select>
            </template>
            <input
              v-else
              v-model="s.property.textValue"
              type="text"
              class="form-control"
              placeholder="Хайх утгаа оруулна уу"
              maxlength="450"
            />
          </div>
        </div>
        <div class="bd-t ht-55 d-flex pd-10 justify-content-between">
          <button
            v-if="$store.state.user.userId != ''"
            @click="exportList()"
            class="btn btn-xs btn-success btn-uppercase"
          >
            Экспорт
          </button>
          <button
            @click="
              pager.currentPage = 0;
              init();
            "
            class="btn btn-xs btn-white btn-uppercase mg-l-auto"
          >
            Хайх
          </button>
          <button
            @click="initSearches"
            class="btn btn-xs btn-primary btn-uppercase mg-l-10"
          >
            Бүгд
          </button>
        </div>
      </div>
      <div class="col-9">
        <div class="" style="height: calc(100vh - 115px); overflow: auto">
        <!-- <div v-for="(l,i) in list" :key="i">
          <div>{{l.task}}</div>
        </div> -->
          <b-table
            @row-clicked="rowClicked"
            striped
            hover
            :fields="fields"
            :items="list"
            :per-page="pager.perPage"
            :current-page="pager.currentPage"
            show-empty
          >
            <template #empty>
              <div class="container d-flex justify-content-center ht-100p">
                <div
                  :style="`height:calc(100vh - ${
                    $store.state.user.userId != '' ? '240' : '210'
                  }px)`"
                  class="
                    mx-wd-300
                    wd-sm-450
                    ht-100p
                    d-flex
                    flex-column
                    align-items-center
                    justify-content-center
                    pd-t-100
                  "
                >
                  <div class="wd-80p wd-sm-300 mg-b-15">
                    <img src="assets/svg/boxempty.svg" class="img-fluid" alt />
                  </div>
                  <h4 class="tx-20 tx-sm-24 text-muted">
                    Мэдээлэл хоосон байна
                  </h4>
                </div>
              </div>
            </template>
          </b-table>
        </div>
        <div class="bd-t d-flex align-items-center ht-55 pd-x-20">
<!-- @change="pageChanged" :value="pager.currentPage + 1" -->
          <b-pagination
            v-model="pager.currentPage"
            :total-rows="pager.rows"
            :per-page="pager.perPage"
            class="pd-t-15"
            size="sm"
            
          ></b-pagination>
          <!--  -->
          <!-- <button class="mg-l-auto btn btn-xs btn-success btn-uppercase">Бүгдийг нэмэх</button> -->
        </div>
      </div>
    </div>

    <task-edit
      :prms.sync="taskEdit"
      :show.sync="taskEdit.show"
      @on-attach="showFile($event)"
      @on-task-posted="initSearches"
      @on-edit-close="editClosed"
    ></task-edit>

    <task-detail-side
      v-if="taskDialogSide.id > 0"
      :id.sync="taskDialogSide.id"
      @on-task-close="taskDialogSide.id = 0"
      @on-task-delete="onTaskDelete"
      @on-task-reload="onTaskReload"
      @on-row-updated="initRow"
    ></task-detail-side>

    <file-dialog
      :show.sync="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />
  </div>
</template>

<script>
import mainHeader from "@/views/apps/ipom/components/header.vue";
import { request } from "@/api/all";
import { mapActions } from "vuex";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import "element-ui/lib/theme-chalk/index.css";
import { DatePicker, Select, Option } from "element-ui";

export default {
  components: {
    DatePicker,
    Select,
    Option,
    mainHeader,
    taskEdit: () => ({
      component: import("@/components/task/edit/base"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskDetailSide: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      pager: {
        filtered: 0,
        currentPage: 0,
        perPage: 20,
        rows: 0,
      },
      fields: [
        {
          key: "task",
          label: "Нэр",
          sortable: true,
        },
        {
          key: "st1",
          label: "Улсын бүртгэлийн дугаар",
          sortable: true,
        },
      ],
      list: [],
      searches: [],
      filter: {
        task: null,
        st1: null,
      },

      project: {
        id: 0,
        title: "",
      },
      taskEdit: {
        id: 0,
        show: false,
        render: false,
        objectTypeId: 0,
        projectId: 0,
      },
      ot: -1,
      taskDialogSide: {
        show: false,
        id: 0,
        key: 0,
      },
      fileDialog: {
        show: false,
        id: 0,
      },
    };
  },
  mounted() {
    //this.$store.state.app.activeGroup.publicPage.mainObjectTypeId
    //if
    this.initSearches();
  },
  methods: {
    ...mapActions(["handleAside"]),
    initSearches() {
      //console.log("initSearches fired");
      this.ot =
        this.$route.params.lid == 95327 || this.$route.params.lid == 95326
          ? 526
          : 527;
      let prjs = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == this.ot
      );
      if (prjs != undefined && prjs.length) {
        this.project = prjs[0];
      }

      if (this.$store.state.user.userId != "") {
        this.handleAside({ minimize: false, maximize: true });
      }

      this.filter.task = null;
      this.filter.st1 = null;
      request({
        api: { method: "GET", url: "Ltdb/GetFields" },
        params: { locTypeId: this.$route.params.lid },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          //console.log("Ltdb/GetFields=> ", res.data.fields);
          this.searches = res.data.fields;
          this.init();
        }
      });
    },
    pageChanged(e) {
      this.pager.currentPage = e - 1;
      this.init();
    },
    init() {
      let _props = this.searches
        .filter((f) => f.property.filter && f.property.showClient)
        .map((f) => {
          return {
            id: f.id,
            textValue: f.property.textValue,
            values: f.property.selectedValues,
            struct: f.property.struct,
            type: f.property.type,
          };
        });
      request({
        api: { method: "POST", url: "Ltdb/TaskList" },
        data: {
          //page: this.pager.currentPage,
          //size: this.pager.perPage,
          page: 0,
          size: 10000,
          task: this.filter.task,
          st1: this.filter.st1,
          objectTypeId: this.ot,
          locTypeId: this.$route.params.lid,
          properties: _props,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          //console.log(res);
          //console.log(res);
          this.fields = [
            {
              key: "task",
              label: "Нэр",
              sortable: true,
              stickyColumn: true,
              isRowHeader: true,
              //variant: 'info',
              class: "wd-20p",
            },
            {
              key: "st1",
              label: "Улсын бүртгэлийн дугаар",
              sortable: true,
              class: "wd-10p",
            },
          ];

          if (this.ot == 527) {
            //console.log("dd added")
            this.fields.push({
              key: "dueDate",
              label: "Лицензийн хугацаа",
              sortable: true,
              class: "wd-10p",
            });
          }
          //console.log(this.fields)
          this.fields = this.fields.concat(
            this.searches.map((x) => {
              return {
                key: `ps_${x.id}`,
                label: x.property.title,
                sortable: true,
                //calss: 'wd-10p text-truncate'
              };
            })
          );

          res.data.list.forEach((item) => {
            item.properties.forEach((prop) => {
              //console.log('properties',prop.type);
              if (prop.type != undefined && prop.type == 2) {
                //console.log('properties', item, prop);
                item["ps_" + prop.id] = item.properties
                  .filter((x) => x.id == prop.id)
                  .map((z) => {
                    return z.value.text;
                  })
                  .join(", ");
              } else item["ps_" + prop.id] = prop.value.text;
            });
          });
          //console.log("res.data.list", res.data.list);
          this.list = res.data.list;
          this.pager.rows = res.data.allCount;
        }
      });
    },
    editShow(id) {
      this.taskEdit.id = id;
      this.taskEdit.objectTypeId = this.ot;
      this.taskEdit.projectId = this.project.id;
      this.taskEdit.render = true;
      this.$nextTick(function () {
        this.taskEdit.show = true;
      });
    },
    editClosed() {
      //console.log('editClosed');
      this.taskEdit.render = false;
      this.taskEdit.show = false;
      this.taskEdit.id = 0;
    },
    rowClicked(e) {
      if (this.$store.state.user.userId != "") {
        this.taskDialogSide.id = e.id;
      } else {
        //alert('busket coming soon');
      }
    },
    onTaskDelete(e) {
      this.taskDialog.id = 0;
      let cur = this.list.filter((x) => x.id == e);
      if (cur.length > 0) {
        let i = this.list.map((st) => st.id).indexOf(e);
        this.list.splice(i, 1);
        this.pager.rows = this.pager.rows - 1;
      }
    },
    onTaskReload(e) {
      //console.log("onTaskReload", e);
      this.taskDialogSide.id = 0;
      this.$nextTick(function () {
        this.init();
        this.taskDialogSide.id = e.obj.id;
      });
    },
    initRow(id) {
      //console.log("initRow fired");
      this.init();
      // //console.log(id);
      // this.handleLoading({ isLoading: true });
      // this.filterModel.id = id;
      // let self= this;
      // getCoreList({
      //   data: {
      //     projectId: this.project.id,
      //     size: 1,
      //     skip: (this.pager.current - 1) * this.pager.perPage,
      //     model: this.filterModel,
      //   },
      //   store: this.$store,
      // }).then((res) => {
      //   this.handleLoading({ isLoading: false });

      //   if (res != false) {

      //     // res.data.tasks = res.data.tasks.map((e) =>
      //     //   Object.assign(e, {
      //     //     groupDate: self.getDateGroupName(e.createdDate),
      //     //     k: null,
      //     //   })
      //     // );

      //     const currentIndex = this.list.findIndex((p) => p.id === id);
      //     this.list.splice(currentIndex, 1, res.data.tasks[0]);
      //   }
      // });
    },
    exportList() {
      let _props = this.searches
        .filter((f) => f.property.filter && f.property.showClient)
        .map((f) => {
          return {
            id: f.id,
            textValue: f.property.textValue,
            values: f.property.selectedValues,
            struct: f.property.struct,
          };
        });
      request({
        api: { method: "POST", url: "Ltdb/TaskExport" },
        data: {
          task: this.filter.task,
          objectTypeId: this.ot,
          locTypeId: this.$route.params.lid,
          properties: _props,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.showFile(res.data.file.id);
        }
      });
    },
    showFile(id) {
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
  },

  watch: {
    "$root.$route"() {
      this.initSearches();
    },
  },
};
</script>

<style></style>
